// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"ee47432e","756":"41348c5b"}[chunkId] + ".chunk.js";
};